trustedText = ($sce) ->
  (text) ->
    a = 1
    $sce.trustAsHtml text.toString()

trustedText.$inject = [
  '$sce'
]

module.exports = trustedText


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/trusted-text-filter.coffee